(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	$('.toggle-class').each(function () {
		var trigger = $(this);

		trigger.on('click', function (e) {
			e.preventDefault();
			trigger.toggleClass('active');

			if (trigger.is('.active')) {
				$(document.documentElement).addClass('toggle-class-active')
			}
		});
	});
})();
